import {
  Box,
  StepConnector as MuiStepConnector,
  StepLabel as MuiStepLabel,
  Stepper as MuiStepper,
  styled,
} from '@mui/material';

export const StyledStepper = styled(MuiStepper)(() => ({
  '& .MuiStep-root:first-of-type': {
    paddingLeft: 0,
  },
  '& .MuiStep-root:last-of-type': {
    paddingRight: 0,
  },
}));

export const StyledStepLabel = styled(MuiStepLabel)(({ theme }) => ({
  '& .MuiStepIcon-root': {
    width: '14px',
    height: '14px',
    [theme.breakpoints.up('sm')]: {
      width: '32px',
      height: '32px',
    },
  },
}));

export const StyledStepConnector = styled(MuiStepConnector)<{
  isTabletOrMobile?: boolean;
}>(({ theme }) => ({
  top: '16px',
  [theme.breakpoints.down('sm')]: {
    top: '8px',
  },
  '& .MuiStepConnector-line': {
    borderColor: theme.palette.text.fifth,
  },
}));

export const StyledPayoutStepIcon = styled(Box)<{
  error?: boolean;
}>(({ theme, error }) => {
  const backgroundColor = error
    ? theme.palette.error.main
    : theme.palette.primary.main;

  return {
    width: '14px',
    height: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor,
    [theme.breakpoints.up('sm')]: {
      width: '32px',
      height: '32px',
    },
    '& svg': {
      width: '8px',
      height: '8px',
      [theme.breakpoints.up('sm')]: {
        width: '16px',
        height: '16px',
      },
    },
  };
});
